/* src/components/project-risk-rainbow/project-risk-rainbow.component.scss */
:host {
  display: block;
}
.vwui-table-row--with-hover:hover {
  cursor: pointer;
  background-color: #EEF1FA;
}
.filters-toggle {
  transform: translateY(0.75rem);
}
.total-in-per {
  font-weight: var(--vwui-font-weight-semibold);
  color: var(--vwui-color-neutral-1);
  display: inline;
}
.sortable-label {
  height: 15px;
  width: 15px;
}
.sortable-label--pdf-size {
  height: 5pt;
  width: 5pt;
}
/*# sourceMappingURL=project-risk-rainbow.component-F5AHYWWS.css.map */
